import { render, staticRenderFns } from "./CmdCardInkas.vue?vue&type=template&id=5deb4c3f&scoped=true&"
import script from "./CmdCardInkas.vue?vue&type=script&lang=js&"
export * from "./CmdCardInkas.vue?vue&type=script&lang=js&"
import style0 from "./CmdCardInkas.vue?vue&type=style&index=0&id=5deb4c3f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deb4c3f",
  null
  
)

export default component.exports